export const updateMetaTags = (meta) => {
  // Update title
  document.title = meta.title || "";

  // Update or create meta tags
  const updateOrCreateMeta = (name, content) => {
    let element = document.querySelector(`meta[name="${name}"]`);
    if (!element) {
      element = document.createElement("meta");
      element.name = name;
      document.head.appendChild(element);
    }
    element.content = content;
  };

  if (meta.description) updateOrCreateMeta("description", meta.description);
  if (meta.keywords) updateOrCreateMeta("keywords", meta.keywords);

  // Update OG tags
  const updateOrCreateOG = (property, content) => {
    let element = document.querySelector(`meta[property="${property}"]`);
    if (!element) {
      element = document.createElement("meta");
      element.setAttribute("property", property);
      document.head.appendChild(element);
    }
    element.content = content;
  };

  if (meta.ogImage) updateOrCreateOG("og:image", meta.ogImage);
  if (meta.title) updateOrCreateOG("og:title", meta.title);
  if (meta.canonical) updateOrCreateOG("og:url", meta.canonical);
  if (meta.description) updateOrCreateOG("og:description", meta.description);
  updateOrCreateOG("og:type", "website");
};
